import { ClassProp } from 'helpers/types';
import React, { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { Icon, Input } from 'semantic-ui-react';

import styles from './Search.styles';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
  performSearch: (searchTerm: string) => void;
  filter: boolean;
  resetSearch: () => void;
};

const Search: FunctionComponent<Props> = ({
  classes,
  performSearch,
  filter,
  resetSearch,
}) => {
  const [enableCancelSearch, setEnableCancelSearch] = useState(false);
  const inputRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (filter) {
      setEnableCancelSearch(true);
    }
  }, [filter]);

  const handleCancelSearch = () => {
    setEnableCancelSearch(false);
    if (inputRef && inputRef.current) {
      (inputRef.current as HTMLInputElement).value = '';
      if (filter) {
        resetSearch();
      }
    }
  };

  const onChangeHandler = (e: SyntheticEvent<HTMLInputElement>) => {
    const searchTerm = (e.target as HTMLInputElement).value;
    if (enableCancelSearch !== searchTerm.length > 0) {
      setEnableCancelSearch(searchTerm.length > 0);
    }
  };

  const onKeyDownHandler = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      const searchTerm = (e.target as HTMLInputElement).value;
      performSearch(searchTerm);
    }
    if (e.key === 'Escape') {
      (inputRef.current as HTMLInputElement).value = '';
      setEnableCancelSearch(false);
      if (filter) {
        resetSearch();
      }
    }
  };

  const onSearchClickHandler = (e: SyntheticEvent<HTMLButtonElement>) => {
    const searchTerm = (e.target as HTMLInputElement).value;
    performSearch(searchTerm);
  };

  return (
    <div className={classes.mainContainer}>
      <span className={classes.searchByLabel}>Search by email</span>
      <div className={classes.searchContainer}>
        <Input
          className={classes.searchInput}
          name="email"
          type="text"
          placeholder="name@gmail.com"
          onKeyUp={onKeyDownHandler}
          onChange={onChangeHandler}
          input={{ ref: inputRef }}
        ></Input>
        {enableCancelSearch ? (
          <button onClick={handleCancelSearch}>
            <Icon name="cancel"></Icon>
          </button>
        ) : (
          <button onClick={onSearchClickHandler}>
            <Icon name="search"></Icon>
          </button>
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(Search);
